import { render, staticRenderFns } from "./AnswerForm.vue?vue&type=template&id=4ad95b53&"
import script from "./AnswerForm.vue?vue&type=script&lang=js&"
export * from "./AnswerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports